import { h, Component } from 'preact';
import style from './index.less'
import _ from 'lodash'

export default (props)=>{
    const classes = [style.col]
    if(props.span){
        for(let k of Object.keys(props.span)){
            classes.push(
                style[`col-${k}-${props.span[k]}`]
            )
        }
    }
    props.class && classes.push(props.class)
    return (
        <div class={_.flatten(classes).join(' ')} onClick={props.onClick}>
            {props.children}
        </div>
    )
}


// WEBPACK FOOTER //
// ./components/elements/Col/index.js